import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { AdminProtectedRoute } from '../components/admin/AdminProtectedRoute';
import { AdminLayout } from '../components/admin/AdminLayout';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import SobrePage from '../pages/sobre/page';
import ContactosPage from '../pages/contactos/page';
import PoliticasPrivacidadePage from '../pages/politicas-privacidade/page';
import TermosCondicoesPage from '../pages/termos-condicoes/page';
import AgenciaViagensPage from '../pages/agencia-viagens/page';
import LojaServicosPage from '../pages/loja-servicos/page';
import AgendamentoPage from '../pages/agendamento/page';

const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminAgendamentosPage = lazy(() => import('../pages/admin/agendamentos/page'));
const AdminConsultasPage = lazy(() => import('../pages/admin/consultas/page'));
const AdminPagamentosPage = lazy(() => import('../pages/admin/pagamentos/page'));
const AdminBlogPage = lazy(() => import('../pages/admin/blog/page'));
const AdminGaleriaPage = lazy(() => import('../pages/admin/galeria/page'));
const AdminConfiguracoesPage = lazy(() => import('../pages/admin/configuracoes/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contactos',
    element: <ContactosPage />,
  },
  {
    path: '/politicas-privacidade',
    element: <PoliticasPrivacidadePage />,
  },
  {
    path: '/termos-condicoes',
    element: <TermosCondicoesPage />,
  },
  {
    path: '/agencia-viagens',
    element: <AgenciaViagensPage />,
  },
  {
    path: '/loja-servicos',
    element: <LojaServicosPage />,
  },
  {
    path: '/agendamento',
    element: <AgendamentoPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: (
      <AdminProtectedRoute>
        <AdminLayout />
      </AdminProtectedRoute>
    ),
    children: [
      {
        path: 'dashboard',
        element: <AdminDashboardPage />,
      },
      {
        path: 'agendamentos',
        element: <AdminAgendamentosPage />,
      },
      {
        path: 'consultas',
        element: <AdminConsultasPage />,
      },
      {
        path: 'pagamentos',
        element: <AdminPagamentosPage />,
      },
      {
        path: 'blog',
        element: <AdminBlogPage />,
      },
      {
        path: 'galeria',
        element: <AdminGaleriaPage />,
      },
      {
        path: 'configuracoes',
        element: <AdminConfiguracoesPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
